import { compose } from 'recompose';
import { connect } from 'react-redux';

import {
  fetchMetricsData,
} from '../../../../../actions/metrics';
import {
  CHART_QUOTA_DAILY,
  HISTORICAL_METRIC_30DAYS,
  HISTORICAL_METRIC_52WEEKS,
} from '../../../../../constants/charts';
import {
  getApisWithRLQList,
  getChartData,
  getChartParams,
  getOrgMap,
  getIsChartLoading,
  getIsMetricTypeDataLoading,
} from '../../../../../reducers/metrics';

import DailyQuotaChart from '../../../../../components/Analytics/CannedCharts/UsageCharts/DailyQuotaChart';

const metric = 'usage';

export const mapDispatchToProps = (dispatch) => ({
  fetchCustomDateMetricsData: (params) =>
    dispatch(
      fetchMetricsData(
        CHART_QUOTA_DAILY,
        params,
        metric,
        params.aggregation,
        params.usageType,
      ),
    ),
});

export const mapStateToProps = (state) => ({
  defaultUsageResponse: getChartData(state, CHART_QUOTA_DAILY),
  apiMap: getApisWithRLQList(state),
  orgMap: getOrgMap(state),
  usageResponseFor30DaysAgo:
    getChartData(
      state,
      CHART_QUOTA_DAILY,
      HISTORICAL_METRIC_30DAYS,
    ),
  usageResponseFor52WeeksAgo:
    getChartData(
      state,
      CHART_QUOTA_DAILY,
      HISTORICAL_METRIC_52WEEKS,
    ),
  isLoading: getIsChartLoading(state, CHART_QUOTA_DAILY),
  is30DaysDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_QUOTA_DAILY,
    HISTORICAL_METRIC_30DAYS,
  ),
  is52WeeksDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_QUOTA_DAILY,
    HISTORICAL_METRIC_52WEEKS,
  ),
  usageParams: getChartParams(state, CHART_QUOTA_DAILY),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(DailyQuotaChart);
